import { useQuery } from '@tanstack/react-query';
import { fetcher } from 'src/api/fetcher';
import { API_RESOURCES } from 'src/utils/constants';
import { getUuid } from 'src/utils/url';

export const useBatch = (batchUri, batchKey = 'source-batch-uri') => {
  return useQuery({
    queryKey: ['batch', batchKey, batchUri],
    queryFn: () => fetcher(`${API_RESOURCES.MATERIAL_BATCH}/${getUuid(batchUri)}`),
    enabled: !!batchUri,
  });
};

export const useBatchActionsByUri = (transactionBatchActions, batchKey = 'get-batch-actions') => {
  return useQuery({
    queryKey: ['batch-actions', batchKey, transactionBatchActions],
    queryFn: () =>
      fetcher(API_RESOURCES.MATERIAL_BATCH_ACTION, {
        params: {
          'filter[uri]': transactionBatchActions,
        },
      }),
    enabled: !!transactionBatchActions && transactionBatchActions.length > 0,
    select: data => {
      const resources = data.resources;
      return Object.fromEntries(resources.map(item => [item.uri, item]));
    },
  });
};
